<script setup>
import { fitItems } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec">
    <div class="m-center">
      <span class="m-kicker">啱 唔 啱 你</span>
    </div>
    <h2 class="m-title">呢個班，為邊種人而設？</h2>
    <div class="m-fit">
      <div
        v-for="(item, i) in fitItems"
        :key="i"
        class="m-fit-item"
      >
        <img
          :src="item.icon"
          alt=""
          class="m-fit-icon"
          loading="lazy"
        />
        <div>
          <b class="m-fit-title">{{ item.title }}</b>
          <p class="m-fit-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-center {
  text-align: center;
}

.m-kicker {
  display: inline-block;
  font-size: 24px;
  letter-spacing: 8px;
  color: #a8823f;
  border: 2px solid #c9a25e;
  padding: 8px 24px;
  border-radius: 999px;
  margin-bottom: 24px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-fit {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  margin-top: 40px;
}

.m-fit-item {
  display: flex;
  align-items: center;
  gap: 28px;
  background: #fff;
  border: 1px solid #e7dfcc;
  border-radius: 18px;
  padding: 36px 32px;
}

.m-fit-icon {
  width: 112px;
  height: 112px;
  object-fit: contain;
  flex: none;
}

.m-fit-title {
  font-size: 30px;
  color: #16241d;
}

.m-fit-desc {
  font-size: 25px;
  color: #6f6a5c;
  margin-top: 8px;
}
</style>
